// extracted by mini-css-extract-plugin
module.exports = {"nav":"Footer_nav_2vdnR","navItem":"Footer_navItem_3YApi","copyright":"Footer_copyright_1NVD2"};